import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const coverageTypeApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'coverageTypeApi',
  tagTypes: ['ClientList', 'CoverageType'],
  endpoints: () => ({})
})

export default coverageTypeApi
